import { render, staticRenderFns } from "./BusinessInfoSection.vue?vue&type=template&id=42387c1c&"
import script from "./BusinessInfoSection.vue?vue&type=script&lang=js&"
export * from "./BusinessInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports